import React from "react";
import { ADSENSE_CLIENT, AD_UNITS } from "../config/ads";
import AdSlot from "../components/AdSlot";

const STEPS = [
  {
    t: "Deploy & pakai domain sendiri",
    d: "AdSense tidak menerima subdomain preview. Deploy situs, lalu hubungkan domain milik Anda (mis. goalpulse.com).",
  },
  {
    t: "Daftar Google AdSense",
    d: "Buka adsense.google.com → Sign up → masukkan domain Anda. Anda akan mendapat Publisher ID berbentuk ca-pub-1234567890123456.",
  },
  {
    t: "Isi Publisher ID",
    d: "Tambahkan REACT_APP_ADSENSE_CLIENT=ca-pub-xxxxxxxx di frontend/.env (atau di Secrets saat deploy). Script AdSense otomatis dimuat di semua halaman — ini juga dipakai Google untuk verifikasi situs.",
  },
  {
    t: "Isi ads.txt",
    d: "Edit frontend/public/ads.txt dan ganti baris contoh dengan: google.com, pub-xxxxxxxx, DIRECT, f08c47fec0942fa0",
  },
  {
    t: "Buat ad unit",
    d: "Setelah disetujui: AdSense → Ads → By ad unit → Display ads. Buat unit untuk tiap ukuran (728x90, 970x250, 300x250, 300x600, 320x100, Responsive, In-feed). Salin angka data-ad-slot.",
  },
  {
    t: "Tempel ID slot",
    d: "Isi AD_UNITS di frontend/src/config/ads.js. Satu ID per ukuran sudah cukup — otomatis dipakai di semua penempatan ukuran itu. Placeholder langsung berubah jadi iklan asli.",
  },
];

const PLACEMENTS = [
  ["Semua halaman", "Header/hero leaderboard 728x90 (mobile 320x100), footer leaderboard"],
  ["Home", "Sidebar 300x250 ×4, 300x600 ×1, billboard 970x250 ×2 di tengah & bawah"],
  ["Matches", "Top leaderboard, in-feed setiap 2 liga, sidebar sticky 300x250 + 300x600, billboard bawah"],
  ["Standings / Teams", "Top leaderboard, sidebar sticky, billboard bawah, iklan di popup tim"],
  ["News & Artikel", "Top, sidebar, billboard tengah; artikel: atas, di dalam teks (300x250), bawah"],
];

export default function AdsGuide() {
  const configured = Object.entries(AD_UNITS).filter(([, v]) => v).length;
  return (
    <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8" data-testid="ads-guide">
      <div className="overline-eyebrow text-primary">Owner Guide</div>
      <h1 className="font-display text-5xl uppercase leading-none sm:text-6xl">Cara Memasang Iklan</h1>
      <p className="mt-3 text-sm text-muted-foreground">
        Semua kotak bertanda &quot;ADVERTISEMENT&quot; di situs ini sudah siap untuk Google AdSense. Ikuti 6 langkah di bawah.
      </p>

      <div className="mt-6 grid gap-3 sm:grid-cols-2" data-testid="ads-status">
        <div className="border border-border bg-card p-4">
          <div className="overline-eyebrow text-muted-foreground">Publisher ID</div>
          <div className={`mt-1 font-display text-2xl ${ADSENSE_CLIENT ? "text-primary" : ""}`}>{ADSENSE_CLIENT || "Belum diisi"}</div>
        </div>
        <div className="border border-border bg-card p-4">
          <div className="overline-eyebrow text-muted-foreground">Ad units terisi</div>
          <div className="mt-1 font-display text-2xl">{configured} / {Object.keys(AD_UNITS).length}</div>
        </div>
      </div>

      <ol className="mt-10 space-y-4">
        {STEPS.map((s, i) => (
          <li key={s.t} className="flex gap-4 border border-border bg-card p-5">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-primary font-display text-2xl text-primary-foreground">{i + 1}</span>
            <div>
              <h2 className="font-display text-2xl uppercase">{s.t}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{s.d}</p>
            </div>
          </li>
        ))}
      </ol>

      <h2 className="mt-12 border-b border-border pb-2 font-display text-3xl uppercase">Peta Lokasi Iklan</h2>
      <div className="mt-4 divide-y divide-border border border-border bg-card">
        {PLACEMENTS.map(([page, where]) => (
          <div key={page} className="grid gap-1 p-4 sm:grid-cols-[180px_1fr]">
            <span className="font-display text-xl uppercase">{page}</span>
            <span className="text-sm text-muted-foreground">{where}</span>
          </div>
        ))}
      </div>

      <h2 className="mt-12 border-b border-border pb-2 font-display text-3xl uppercase">Tips Lolos Review</h2>
      <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-muted-foreground">
        <li>Tambahkan halaman About, Contact & Privacy Policy (wajib untuk AdSense).</li>
        <li>Terbitkan artikel orisinal secara rutin — situs dengan konten tipis sering ditolak.</li>
        <li>Jangan pernah klik iklan sendiri; akun bisa diblokir.</li>
        <li>Alternatif cepat: aktifkan Auto ads di AdSense — Google akan menambah iklan otomatis di samping slot ini.</li>
      </ul>

      <AdSlot size="responsive" slotId="guide-preview" className="mt-10" />
    </div>
  );
}
